export default {
  demo: 'Смотреть пример',
  required: 'Необходимо загрузить файл',
  notAccept: 'Нельзя загружать файлы этого расширения',
  sizeLimit: 'Превышен максимальный размер файла',
}